import slide1 from 'common/building-blocks/assets/images/slide-1.jpg';
import slide2 from 'common/building-blocks/assets/images/slide-2.jpg';
import slide3 from 'common/building-blocks/assets/images/slide-3.jpg';
import { COMPONENT_STATES, COMPONENT_TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock } from '../creation-types';
import { image } from '../image/recipe';

const getImgStyles = (backgroundImage: string) => ({
	[COMPONENT_STATES.DEFAULT]: {
		[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
			backgroundImage,
		},
	},
});

export const sliderSlides = (): CreatedBuildingBlock<typeof COMPONENT_TYPE.SLIDER_SLIDES> =>
	createModel({
		type: COMPONENT_TYPE.SLIDER_SLIDES,
		editorProps: {
			draggable: false,
			expandable: true,
			expanded: true,
		},
		componentProps: {
			styles: {},
			other: {},
		},
		children: [
			image({ styles: getImgStyles(slide1) }),
			image({ styles: getImgStyles(slide2) }),
			image({ styles: getImgStyles(slide3) }),
		],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.SLIDER_SLIDES>;
